module.exports = __webpack_public_path__ + "img/login.a9d594ed.svg";